// @flow
import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
} from "react-router-dom";
import DataTableTemplate from "../Cpanel/Components/DataTableTemplate";
import { fetchData, formatNumber } from "../Cpanel/Components/Utilities";

const Coin = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState([]);
  // const {
  //   name,
  //   family,
  //   regdate: userRegDate,
  //   InsPay,
  //   grade,
  // } = useSelector((state) => state.auth);
  const [freeCoin, setFreeCoin] = useState("");
  const [coin, setCoin] = useState({ coin: "", status: "" });
  const location = useLocation();

  const handleBackNavigation = () => {
    if (!location.state) {
      navigate("/");
    } else {
      navigate(location.state);
    }
  };

  let userLevel = "";
  switch (userInfo?.grade) {
    case 0: {
      userLevel = "عادی";
      break;
    }
    case 1: {
      userLevel = "طلایی";
      break;
    }
    case 2: {
      userLevel = "پالادیوم";
      break;
    }
    default: {
      userLevel = "عادی";
    }
  }

  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [userList, setUserList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [defaultRows, setDefaultRows] = useState(20);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  const cols = [
    {
      field: "ckDate",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "ckDate",
      header: "تاریخ",
    },
    { field: "ckTime", header: "زمان" },
    {
      field: "ckIn",
      header: "سکه دریافتی",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.ckIn)}
        </p>
      ),
    },
    {
      field: "ckOut",
      header: "سکه خرج شده",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.ckOut)}
        </p>
      ),
    },
    {
      field: "remain",
      header: "باقیمانده",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.remain)}
        </p>
      ),
    },
    { field: "ckDesc", header: "توضیحات" },
  ];

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("mycoin", bodyFormData, handleApiResponse);

    const bodyUserInfo = new FormData();
    bodyUserInfo.append("guid", Cookies.get("guid"));
    fetchData("guid", bodyUserInfo, handleUserInfoResponse);
  }, [lazyState]);
  const handleApiResponse = (data) => {
    setUserList(data?.dt);
    setTotalRecords(data?.count);
    setCoin({ coin: data?.freeCoin, status: data?.data?.status });
  };
  const handleUserInfoResponse = (data) => {
    setUserInfo(data?.userinfo);
    setFreeCoin(data?.freeCoin);
  };
  return (
    <div className=" container">
      <div className="card wm-100 container">
        <div className="card-body">
          <h5 className="card-title text-center">
            <span className="text-warning">
              <FontAwesomeIcon icon="coins" className="header-icon fs4" />
            </span>{" "}
            سکه های من
          </h5>
          <p className="text-center text-warning fs-6">
            هر پارسی معادل 1000 ریال می باشد
          </p>
          <div className="d-flex flex-columns justify-content-end coins-no mb-0">
            <p className="">{` سکه های قابل استفاده: ${formatNumber(
              coin?.coin
            )}پارسی`}</p>
          </div>
          <hr className="mt-0" />
          <main>
            {/* <div className="d-flex flex-column justify-content-center align-items-center tips ">
              <p className="txt-color-secondary">
                {`سطح کاربری شما`}
                <strong>{`${userLevel}`}</strong> {`می باشد`}
              </p>
              <p className="txt-color-secondary">
                با خرید بیمه نامه سطح کاربری خود را اتفاء دهید سپس می توانید از
                پارسی های اندوخته استفاده کنید
              </p>
            </div> */}
          </main>
          <div className="card">
            <DataTableTemplate
              lazyState={lazyState}
              // select='select'
              className={"table-border"}
              columns={cols}
              list={userList}
              totalRecords={totalRecords}
              setlazyState={setLazyState}
              setDefaultDatatableRows={setDefaultDatatableRows}
              defaultDatatableRows={defaultDatatableRows}
              width="25rem"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coin;
